import "./Basemap.css";

import {DEVICE_PIXEL_RATIO} from "ol/has";
import ImageLayer from "ol/layer/Image";
import TileLayer from "ol/layer/Tile";
import { WMTS as WMTSSource, Raster as RasterSource } from "ol/source";
import WMTSTileGrid from "ol/tilegrid/WMTS";

import RasterHidpiSource from "@/gis/source/RasterHidpi";
// import imageOperation from "./basemapOperation";

function getTileSource() {

  const resolutions = [
    156543.03392811998,
    78271.51696419998,
    39135.758481959994,
    19567.879241008,
    9783.939620504,
    4891.969810252,
    2445.984905126,
    1222.9924525644,
    611.4962262807999,
    305.74811314039994,
    152.87405657047998,
    76.43702828523999,
    38.21851414248,
    19.109257071295996,
    9.554628535647998,
    4.777314267823999,
    2.3886571339119995,
    1.1943285669559998,
    0.5971642834779999,
    0.29858214174039993,
  ];
  const matrixIds = [...resolutions.keys()].map(item => item.toString());
  const origin = [-20037508.3428, 20037508.3428];

  type RequestEncoding = 'KVP' | 'REST';

  const tileGrid = new WMTSTileGrid({
    origin,
    resolutions,
    matrixIds
  });

  const options = {
    crossOrigin: "Anonymous",
    format: "image/jpeg",
    layer: 'bmaphidpi',
    matrixSet: "google3857",
    projection: "google3857",
    requestEncoding: "REST" as RequestEncoding,
    style: "normal",
    tileGrid,
    tilePixelRatio: (DEVICE_PIXEL_RATIO > 1) ? 2 : 1,
    transition: 0,
    url: "https://mapsneu.wien.gv.at/basemap/{Layer}/{Style}/{TileMatrixSet}/{TileMatrix}/{TileRow}/{TileCol}.jpeg?skipcache=" + window.location.hostname.replace(".", ""),
  };

  return new WMTSSource( options )
}

export default class BasemapLayer extends ImageLayer<any> {
  tileLayer: TileLayer<any>;

  constructor() {

    const tileSource = getTileSource();

    const rasterSource = (DEVICE_PIXEL_RATIO > 1)
      ? new RasterHidpiSource({ sources: [ tileSource ], operation: function (pixels) {return pixels[0];} })
      : new RasterSource({ sources: [ tileSource ], operation: function (pixels) {return pixels[0];} })
    ;

    const className = 'bmap';
    super({ source: rasterSource, className });
    this.tileLayer = new TileLayer({ source: tileSource, preload: Infinity, className });

  }

  getTileLayer(): TileLayer<any> {
    return this.tileLayer;
  }

}
